(function () {
  const pad2 = (n) => String(n).padStart(2, '0');

  document.querySelectorAll('.tm-slider').forEach((section) => {
    const track = section.querySelector('.tm-slider__track');
    const slides = Array.from(section.querySelectorAll('.tm-slider__slide'));
    const prev = section.querySelector('[data-tm-prev]');
    const next = section.querySelector('[data-tm-next]');
    const counterEl = section.querySelector('[data-tm-counter]');
    const total = slides.length;

    const updateCounter = () => {
      const idx = Math.round(track.scrollLeft / track.clientWidth) + 1;
      counterEl.textContent = `${pad2(idx)} / ${pad2(total)}`;
      prev.disabled = idx === 1;
      next.disabled = idx === total;
    };

    // init
    updateCounter();

    // buttons
    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });

    // react to scroll/resize
    let t;
    track.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(updateCounter, 80);
    });
    new ResizeObserver(updateCounter).observe(track);

    // autoplay (optional)
    const autoplay = section.closest('section')?.dataset?.autoplay || '{{ section.settings.autoplay }}';
    const speed = Number('{{ section.settings.autoplay_speed }}');
    if (String(autoplay) === 'true' && total > 1) {
      let timer = setInterval(() => {
        const idx = Math.round(track.scrollLeft / track.clientWidth) + 1;
        if (idx >= total) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        }
      }, isNaN(speed) ? 5000 : speed);
      section.addEventListener('mouseenter', () => clearInterval(timer));
      section.addEventListener('mouseleave', () => {
        timer = setInterval(() => {
          const idx = Math.round(track.scrollLeft / track.clientWidth) + 1;
          if (idx >= total) track.scrollTo({ left: 0, behavior: 'smooth' });
          else track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        }, isNaN(speed) ? 5000 : speed);
      });
    }

    // INNER sliders per slide
    section.querySelectorAll('[data-inner-slider]').forEach((wrap) => {
      const innerTrack = wrap.querySelector('.tm-slider__inner-track');
      const iPrev = wrap.querySelector('[data-inner-prev]');
      const iNext = wrap.querySelector('[data-inner-next]');
      const iSlides = wrap.querySelectorAll('.tm-slider__inner-slide');

      const enable = () => {
        const idx = Math.round(innerTrack.scrollLeft / innerTrack.clientWidth) + 1;
        iPrev.disabled = idx === 1;
        iNext.disabled = idx === iSlides.length;
      };
      enable();

      iPrev?.addEventListener('click', () => {
        innerTrack.scrollBy({ left: -innerTrack.clientWidth, behavior: 'smooth' });
      });
      iNext?.addEventListener('click', () => {
        innerTrack.scrollBy({ left: innerTrack.clientWidth, behavior: 'smooth' });
      });
      let it;
      innerTrack.addEventListener('scroll', () => {
        clearTimeout(it);
        it = setTimeout(enable, 80);
      });
      new ResizeObserver(enable).observe(innerTrack);

      // hide arrows if only one image
      if (iSlides.length <= 1) {
        iPrev?.remove();
        iNext?.remove();
      }
    });
  });
})();